import { useEffect } from 'react';

// Lightweight loader for GA4, Microsoft Clarity, and Google Search Console verification.
// All IDs come from env variables — when not set, nothing is loaded.
const GA4_ID = process.env.REACT_APP_GA4_ID;
const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;
const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION;

function appendOnce(id, build) {
  if (document.getElementById(id)) return;
  build(id);
}

export default function AnalyticsLoader() {
  useEffect(() => {
    // GA4
    if (GA4_ID) {
      appendOnce('ga4-src', (id) => {
        const s = document.createElement('script');
        s.id = id;
        s.async = true;
        s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
        document.head.appendChild(s);
      });
      appendOnce('ga4-init', (id) => {
        const s = document.createElement('script');
        s.id = id;
        s.innerHTML = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${GA4_ID}');`;
        document.head.appendChild(s);
      });
    }

    // Microsoft Clarity
    if (CLARITY_ID) {
      appendOnce('clarity-init', (id) => {
        const s = document.createElement('script');
        s.id = id;
        s.innerHTML = `(function(c,l,a,r,i,t,y){
c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "${CLARITY_ID}");`;
        document.head.appendChild(s);
      });
    }

    // Google Search Console verification meta tag
    if (GSC_VERIFICATION) {
      appendOnce('gsc-meta', (id) => {
        const m = document.createElement('meta');
        m.id = id;
        m.name = 'google-site-verification';
        m.content = GSC_VERIFICATION;
        document.head.appendChild(m);
      });
    }
  }, []);

  return null;
}
